import type { KeyInfo } from "@/FundExplorer/components/Display/FundOverview/types";

export default function getOverviewYield(
	data: KeyInfo["yields"]["data"],
): [string, string] {
	const nullValue = ["", ""] as [string, string];
	if (!data || data.length === 0) {
		return nullValue;
	}
	const [meta, ...rows] = data;
	const [, key] = meta;
	if (!key) {
		return nullValue;
	}
	return (rows.find((row) => row[0] === key) ?? nullValue) as [string, string];
}
